// extracted by mini-css-extract-plugin
export default {"formRow":"CustomStateModal_formRow__k11+B","removeIcon":"CustomStateModal_removeIcon__QZSmD"};